<template>
  <v-container>
    <v-row>
      <v-col :cols="12" :md="6" class="d-flex align-center">
        <v-card flat color="transparent">
          <v-card-title class="pb-0">
            <h1>Saisonstellen mit Ganzjahresperspektive</h1>
          </v-card-title>
          <v-card-text>
            Jobs2share bündelt Sommer- und Winter-Saisonstellen zu spannenden
            Ganzjahresperspektiven und bringt Fachkräfte und Arbeitgeber unkompliziert zusammen.
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="!authReady"
              color="primary"
              outlined
              class="ml-2"
              style="text-transform: none;"
              @click="showUserRegistrationDialog()"
              depressed
            >
              Registrieren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :cols="12" :md="6">
        <v-img
          src="/static/illustrations/ganzjahresperspektive.jpg"
          contain
          aspect-ratio="1.7"
        />
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col :cols="12" :sm="10" :md="8">
        <searchpanel/>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="6" class="d-flex align-center">
        <v-card flat color="transparent">
          <v-card-title class="pb-0">
            <h2>{{ $t('content.jobFind.label') }}</h2>
          </v-card-title>
          <v-card-text class="pb-0">
            <p>{{ $t('content.howItWorksEmployee.text1') }}</p>
            <p>{{ $t('content.howItWorksEmployee.text2') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              outlined
              class="ml-2"
              style="text-transform: none;"
              :to="{ name: 'page.find-a-job' }"
              depressed
            >
              Mehr erfahren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :cols="12" :md="6">
        <v-img
          src="/static/illustrations/job-finden.jpg"
          contain
          aspect-ratio="1.7"
        />
      </v-col>
    </v-row>
    <v-row class="flex-sm-row-reverse">
      <v-col :cols="12" :md="6" class="d-flex align-center">
        <v-card flat color="transparent">
          <v-card-title class="pb-0">
            <h2>{{ $t('content.jobAdvertisement.label') }}</h2>
          </v-card-title>
          <v-card-text>
            {{ $t('content.offerEmployers.text') }}
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              outlined
              class="ml-2"
              style="text-transform: none;"
              :to="{ name: 'page.job-advertisement' }"
              depressed
            >
              Mehr erfahren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :cols="12" :md="6">
        <v-img
          src="/static/illustrations/jobs-ausschreiben.jpg"
          contain
          aspect-ratio="1.7"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="6" class="d-flex align-center">
        <v-card flat color="transparent">
          <v-card-title class="pb-0">
            <h2>Live erleben!</h2>
          </v-card-title>
          <v-card-text class="pb-0">
            <p>Zwei Mal im Jahr finden sogenannte Career Days statt.
            Komm vorbei und sprich direkt und unverbindlich mit den
            teilnehmenden Unternehmen und schnapp dir deine nächste Saisonstelle.</p>
            <p>
              Nächster Career Day: 28. Januar 2021
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              outlined
              class="ml-2"
              style="text-transform: none;"
              :to="{ name: 'page.careerday' }"
              depressed
            >
              Mehr erfahren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col :cols="12" :md="6">
        <v-img
          src="/static/illustrations/vor-ort-kennenlernen.jpg"
          contain
          aspect-ratio="1.7"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Searchpanel from '@/components/_organisms/layout/Searchpanel.vue';

export default {
  name: 'Home',
  components: {
    Searchpanel,
  },
  computed: {
    authReady() {
      return this.$auth.check();
    },
  },
  methods: {
    showUserRegistrationDialog() {
      this.$eventBus.$emit('show-user-registration-dialog');
    },
  },
};
</script>
